import { Component, Input } from '@angular/core';
import { XeroAuthService } from 'src/app/shared/services/xero-auth.service';

@Component({
  selector: 'app-xero-button',
  templateUrl: './xero-button.component.html',
  styleUrls: ['./xero-button.component.scss'],
})
export class XeroButtonComponent {
  constructor(private xeroAuth: XeroAuthService) {
    console.log('XeroButtonComponent created');
  }

  initiateXeroSignIn(): void {
    this.xeroAuth.initiateXeroSignIn();
  }
}
